import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SchemesPage = () => {
  // Scheme categories with their full names and abbreviations
  const schemeCategories = [
    { id: 'rrgsa', name: 'RRGSA', fullName: 'RASHTRIYA GRAM SWARAJ ABHIYAN' },
    { id: 'sfc', name: 'SFC', fullName: 'STATE FINANCE COMMISSION' },
    { id: 'tcf', name: 'TCF', fullName: 'TRAINING CORPUS FUND' },
    { id: 'idf', name: 'IDF', fullName: 'INFRASTRUCTURE DEVELOPMENT FUND' },
    { id: 'cfe', name: 'CFE', fullName: 'CENTER FOR EXCELLENCE' },
    { id: 'out', name: 'OUT', fullName: 'OUTSOURCING' },
    { id: 'adm', name: 'ADM', fullName: 'ADMINISTRATION' },
  ];
  
  // Function to handle clicking on a category card
  const handleCategoryClick = (categoryId) => {
    // Navigate to the specific category page or filter the current page
    window.location.href = `/schemes/category/${categoryId}`;
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="relative py-10 bg-blue-800">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-white">Schemes</h1>
              <div className="h-0.5 w-16 bg-white mt-2 mb-4"></div>
              <p className="text-white">
                Explore various schemes and initiatives implemented by the Rural Development and Panchayat Raj Department
              </p>
            </div>
          </div>
        </section>
        
        {/* Scheme Categories Section */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {schemeCategories.map(category => (
            <div 
            key={category.id} 
            className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:shadow-lg"
          >
          
                  <div className="p-6 text-center">
                    <h2 className="text-3xl font-bold text-blue-600 mb-2">{category.name}</h2>
                    <div className="h-0.5 w-16 bg-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-700 font-medium">{category.fullName}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        {/* Schemes Listing Section - Can be moved to separate category pages */}
      
      </main>
      
      <Footer />
    </div>
  );
};

export default SchemesPage;